import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './styles/buyerPreQuotedOptions.scss';
import DeliveryOption from '../shared/delivery/DeliveryOption';
import PreQuoteTitle from '../shared/delivery/PreQuoteTitle';
import PreQuoteDescription from '../shared/delivery/PreQuoteDescription';
import { PreloadedCheckoutDuties } from '../queries/PreloadedCheckoutDuties';

function BuyerPreQuotedOption({
    shipmentQuote,
    isSelected = false,
    onSelect,
    transaction,
    isComputing,
    offerCurrency,
    preloadedDuties,
}) {
    const shipmentQuoteId = get(shipmentQuote, 'serviceId');
    const serviceMethodType = get(shipmentQuote, 'serviceMethod.serviceMethodType');
    const serviceType = get(shipmentQuote, 'serviceMethod.serviceType');
    const queryReference = preloadedDuties?.[shipmentQuoteId] || null;

    return (
        <DeliveryOption
            disabled={isComputing}
            value={shipmentQuoteId}
            title={
                <span className={styles.preQuoteTitle}>
                    <PreQuoteTitle
                        shipmentQuote={shipmentQuote}
                        sku={get(transaction, 'sku')}
                        transaction={transaction}
                        offerCurrency={offerCurrency}
                    />
                </span>
            }
            description={<PreQuoteDescription shipmentQuote={shipmentQuote} />}
            dutiesDescription={
                queryReference ? (
                    <PreloadedCheckoutDuties
                        shipmentQuote={shipmentQuote}
                        queryReference={queryReference}
                    />
                ) : null
            }
            testName={`${serviceMethodType}-${serviceType}`}
            isSelected={isSelected}
            onSelect={() => onSelect({ shipmentType: 'FIRSTDIBS_FACILITATED', shipmentQuoteId })}
        />
    );
}

BuyerPreQuotedOption.propTypes = {
    shipmentQuote: PropTypes.object.isRequired,
    preloadedDuties: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    transaction: PropTypes.object,
    isComputing: PropTypes.bool,
    offerCurrency: PropTypes.string,
    viewer: PropTypes.object,
    queryReference: PropTypes.object,
    destinationCountry: PropTypes.string,
};

const ConnectedBuyerPreQuotedOption = connect(({ transaction, shipping }) => ({
    offerCurrency: transaction.offerCurrency,
    destinationCountry: shipping.defaultCountry,
}))(BuyerPreQuotedOption);

export default createFragmentContainer(ConnectedBuyerPreQuotedOption, {
    shipmentQuote: graphql`
        fragment BuyerPreQuotedOption_shipmentQuote on ShipmentQuote {
            ...PreQuoteDescription_shipmentQuote
            ...PreQuoteTitle_shipmentQuote
            ...PreloadedCheckoutDuties_shipmentQuote
            ...PreQuoteDutiesDescription_shipmentQuote
            serviceId
            serviceMethod {
                serviceType
                serviceMethodType
            }
        }
    `,
    transaction: graphql`
        fragment BuyerPreQuotedOption_transaction on Transaction {
            ...PreQuoteTitle_transaction
            sku {
                ...PreQuoteTitle_sku
            }
            buyer {
                serviceId
            }
            item {
                serviceId
            }
        }
    `,
});
